<template>
  <ImageUpload style="width:70%" />
</template>

<script>
import ImageUpload from "@/components/uploadImage.vue";
export default {
  name: "index",
  components:{
    ImageUpload
  }
}
</script>

<style scoped>

</style>